export const truncateName = (name: string, maxLength: number = 20) => {
    return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
}

export const stateMapToAbbreviation: { [key: string]: string } = {
    "Alabama": "AL",
    "Alaska": "AK", 
    "Arizona": "AZ",
    "Arkansas": "AR",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "Florida": "FL",
    "Georgia": "GA",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Pennsylvania": "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY",
    "District of Columbia": "DC",
    "Puerto Rico": "PR",
    "Virgin Islands": "VI",
    "American Samoa": "AS",
    "Guam": "GU",
    "Northern Mariana Islands": "MP"
};
  
export const getStateAbbreviation = (state: string): string => {
  if (!state || state.trim() === '') {
      return '';
  }
  
  return stateMapToAbbreviation[state] || state;
};

// Utility function to check if transcript is empty or meaningless
export const isEmptyTranscript = (transcript: string | null | undefined): boolean => {
  // Handle null, undefined, or empty string
  if (!transcript || transcript === '') {
    return true;
  }

  // Remove all whitespace and convert to lowercase for analysis
  const cleanText = transcript.trim().toLowerCase();
  
  // Check if empty after trimming
  if (cleanText === '') {
    return true;
  }

  // Check for common "empty" patterns
  const emptyPatterns = [
    // Just punctuation
    /^[.,!?;:\-_\s]*$/,
    
    // Just dots/ellipsis
    /^\.+$/,
    /^…+$/,
    
    // Just dashes or underscores
    /^[\-_]+$/,
    
    // OpenAI/transcription service common empty responses
    /^(no transcript available|transcript not available|no audio detected|silence|quiet)$/,
    /^(um+|uh+|er+|ah+)$/,
    
    // Just repeated characters
    /^(.)\1*$/, // Same character repeated
    
    // Very short meaningless responses (1-2 chars that aren't letters)
    /^[^a-z]{1,2}$/,
  ];

  // Check against empty patterns
  for (const pattern of emptyPatterns) {
    if (pattern.test(cleanText)) {
      return true;
    }
  }

  // Check if it's just a single word that's likely meaningless
  const meaninglessWords = [
    'um', 'uh', 'er', 'ah', 'hmm', 'mhm', 'yeah', 'yes', 'no', 'ok', 'okay'
  ];
  
  const words = cleanText.split(/\s+/).filter(word => word.length > 0);
  if (words.length === 1 && meaninglessWords.includes(words[0])) {
    return true;
  }

  // Check if transcript is too short to be meaningful (less than 3 characters of actual content)
  const actualContent = cleanText.replace(/[^a-z0-9]/g, '');
  if (actualContent.length < 3) {
    return true;
  }

  return false;
};